var map = {
	"./BI.vue": [
		"63f1",
		"vendors",
		"chunk-2d0cf8fe"
	],
	"./ContactService.vue": [
		"2137"
	],
	"./Dashboard.vue": [
		"7277",
		"vendors",
		"chunk-39b034c7"
	],
	"./Downloads.vue": [
		"9d26e",
		"chunk-fcf6fa62"
	],
	"./IFrame.vue": [
		"b7ec",
		"chunk-2d210869"
	],
	"./Iam.vue": [
		"6bd3"
	],
	"./KCHomePage.vue": [
		"824f",
		"vendors",
		"chunk-4b4f616a"
	],
	"./LogIn.vue": [
		"9ddf",
		"vendors",
		"chunk-da9e846e"
	],
	"./Projects.vue": [
		"acca",
		"chunk-2d2138f6"
	],
	"./Team.vue": [
		"0767",
		"chunk-2d0a47fe"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;